Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _animated = require('animated');

var _animated2 = _interopRequireDefault(_animated);

var _reactWithDirection = require('react-with-direction');

var _reactWithDirection2 = _interopRequireDefault(_reactWithDirection);

var _IconChevronNext = require('../exp/icons/IconChevronNext');

var _IconChevronNext2 = _interopRequireDefault(_IconChevronNext);

var _IconChevronPrevious = require('../exp/icons/IconChevronPrevious');

var _IconChevronPrevious2 = _interopRequireDefault(_IconChevronPrevious);

var _withStyles = require('../themes/withStyles');

var _AnimatedScrollContainer = require('./AnimatedScrollContainer');

var _AnimatedScrollContainer2 = _interopRequireDefault(_AnimatedScrollContainer);

var _removeFirefoxButtonPadding = require('../utils/removeFirefoxButtonPadding');

var _removeFirefoxButtonPadding2 = _interopRequireDefault(_removeFirefoxButtonPadding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/no-will-update-set-state: 1 */

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, _reactWithDirection.withDirectionPropTypes, {
  chevronSize: _airbnbPropTypes.nonNegativeInteger,
  children: _propTypes2['default'].node.isRequired,
  defaultScrollLeft: _airbnbPropTypes.nonNegativeInteger,

  // fraction of the scroll container viewport that will scroll per button press
  scrollFactor: _propTypes2['default'].number
}));

var defaultProps = {
  chevronSize: 16,
  defaultScrollLeft: 0,
  scrollFactor: 0.75
};

// number of pixels threshold from the ends of the scroll container
// to determine whether or not the backwards/forwards buttons are visible
var BUTTON_VISIBILITY_THRESHOLD = 10;

var HorizontalScroll = function (_React$Component) {
  _inherits(HorizontalScroll, _React$Component);

  function HorizontalScroll(props) {
    _classCallCheck(this, HorizontalScroll);

    var _this = _possibleConstructorReturn(this, (HorizontalScroll.__proto__ || Object.getPrototypeOf(HorizontalScroll)).call(this, props));

    _this.scrollLeft = props.defaultScrollLeft;

    _this.state = {
      anim: new _animated2['default'].Value(_this.scrollLeft),
      hasScrolled: false,
      showBackwardsButton: false,
      showForwardsButton: false
    };

    _this.maxScrollLeft = 0;
    _this.scrollContainerWidth = 0;

    _this.onButtonBackwardsClick = _this.onButtonBackwardsClick.bind(_this);
    _this.onButtonForwardsClick = _this.onButtonForwardsClick.bind(_this);
    _this.onScroll = _this.onScroll.bind(_this);
    _this.onScrollDimensionsChange = _this.onScrollDimensionsChange.bind(_this);

    _this.state.anim.addListener(function (_ref) {
      var value = _ref.value;

      _this.scrollLeft = value;
      _this.setButtonsVisibility();

      if (!_this.state.hasScrolled) {
        _this.setState({ hasScrolled: true });
      }
    });
    return _this;
  }

  _createClass(HorizontalScroll, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(_ref2) {
        var newDefaultScrollLeft = _ref2.defaultScrollLeft;
        var defaultScrollLeft = this.props.defaultScrollLeft;

        if (newDefaultScrollLeft !== defaultScrollLeft && newDefaultScrollLeft !== null) {
          this.state.anim.setValue(newDefaultScrollLeft);
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'onButtonBackwardsClick',
    value: function () {
      function onButtonBackwardsClick() {
        if (this.props.direction === _reactWithDirection.DIRECTIONS.RTL) {
          this.scrollTowardsRight();
        } else {
          this.scrollTowardsLeft();
        }
      }

      return onButtonBackwardsClick;
    }()
  }, {
    key: 'onButtonForwardsClick',
    value: function () {
      function onButtonForwardsClick() {
        if (this.props.direction === _reactWithDirection.DIRECTIONS.RTL) {
          this.scrollTowardsLeft();
        } else {
          this.scrollTowardsRight();
        }
      }

      return onButtonForwardsClick;
    }()
  }, {
    key: 'onScroll',
    value: function () {
      function onScroll(event) {
        this.state.anim.setValue(event.target.scrollLeft);
      }

      return onScroll;
    }()
  }, {
    key: 'onScrollDimensionsChange',
    value: function () {
      function onScrollDimensionsChange(_ref3) {
        var clientWidth = _ref3.clientWidth,
            scrollWidth = _ref3.scrollWidth;

        var nextMaxScrollLeft = scrollWidth - clientWidth;

        if (this.maxScrollLeft !== nextMaxScrollLeft || this.scrollContainerWidth !== clientWidth) {
          this.maxScrollLeft = scrollWidth - clientWidth;
          this.scrollContainerWidth = clientWidth;
          this.setButtonsVisibility();
        }
      }

      return onScrollDimensionsChange;
    }()
  }, {
    key: 'setButtonsVisibility',
    value: function () {
      function setButtonsVisibility() {
        var isRTL = this.props.direction === _reactWithDirection.DIRECTIONS.RTL;
        var hasLeftClearance = this.scrollLeft > BUTTON_VISIBILITY_THRESHOLD;
        var hasRightClearance = this.scrollLeft < this.maxScrollLeft - BUTTON_VISIBILITY_THRESHOLD;

        var showBackwardsButton = isRTL ? hasRightClearance : hasLeftClearance;
        var showForwardsButton = isRTL ? hasLeftClearance : hasRightClearance;

        var _state = this.state,
            prevBackwards = _state.showBackwardsButton,
            prevForwards = _state.showForwardsButton;


        if (prevBackwards !== showBackwardsButton || prevForwards !== showForwardsButton) {
          this.setState({ showBackwardsButton: showBackwardsButton, showForwardsButton: showForwardsButton });
        }
      }

      return setButtonsVisibility;
    }()
  }, {
    key: 'scrollTowardsLeft',
    value: function () {
      function scrollTowardsLeft() {
        var _this2 = this;

        this.state.anim.stopAnimation(function (value) {
          var delta = _this2.scrollContainerWidth * _this2.props.scrollFactor;
          var nextValue = Math.max(value - delta, 0);
          _animated2['default'].timing(_this2.state.anim, { toValue: nextValue }).start();
        });
      }

      return scrollTowardsLeft;
    }()
  }, {
    key: 'scrollTowardsRight',
    value: function () {
      function scrollTowardsRight() {
        var _this3 = this;

        this.state.anim.stopAnimation(function (value) {
          var delta = _this3.scrollContainerWidth * _this3.props.scrollFactor;
          var nextValue = Math.min(value + delta, _this3.maxScrollLeft);
          _animated2['default'].timing(_this3.state.anim, { toValue: nextValue }).start();
        });
      }

      return scrollTowardsRight;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            css = _props.css,
            chevronSize = _props.chevronSize,
            children = _props.children,
            styles = _props.styles;
        var _state2 = this.state,
            hasScrolled = _state2.hasScrolled,
            showBackwardsButton = _state2.showBackwardsButton,
            showForwardsButton = _state2.showForwardsButton;


        var iconProps = {
          size: chevronSize
        };

        return _react2['default'].createElement(
          'div',
          css(styles.container),
          _react2['default'].createElement(
            _AnimatedScrollContainer2['default'],
            {
              hideHorizontalScrollbar: true,
              onScroll: this.onScroll,
              onScrollDimensionsChange: this.onScrollDimensionsChange,
              scrollLeft: this.state.anim
            },
            children
          ),
          _react2['default'].createElement(
            'div',
            null,
            _react2['default'].createElement(
              'button',
              _extends({
                type: 'button'
              }, css(styles.button, styles.button_backwards, showBackwardsButton && styles.button_visible, !showBackwardsButton && styles.button_hidden, hasScrolled && styles.button_transition, hasScrolled && showBackwardsButton && styles.button_visible_transition, hasScrolled && !showBackwardsButton && styles.button_hidden_transition), {
                'aria-hidden': true,
                onClick: this.onButtonBackwardsClick
              }),
              _react2['default'].createElement(
                'div',
                css(styles.iconContainer, styles.iconContainer_backwards),
                _react2['default'].createElement(
                  'div',
                  css(styles.icon),
                  _react2['default'].createElement(_IconChevronPrevious2['default'], _extends({}, iconProps, { decorative: true }))
                )
              ),
              _react2['default'].createElement('div', css(styles.gradient, styles.gradient_backwards))
            ),
            _react2['default'].createElement(
              'button',
              _extends({
                type: 'button'
              }, css(styles.button, styles.button_forwards, showForwardsButton && styles.button_visible, !showForwardsButton && styles.button_hidden, hasScrolled && styles.button_transition, hasScrolled && showForwardsButton && styles.button_visible_transition, hasScrolled && !showForwardsButton && styles.button_hidden_transition), {
                'aria-hidden': true,
                onClick: this.onButtonForwardsClick
              }),
              _react2['default'].createElement('div', css(styles.gradient, styles.gradient_forwards)),
              _react2['default'].createElement(
                'div',
                css(styles.iconContainer, styles.iconContainer_forwards),
                _react2['default'].createElement(
                  'div',
                  css(styles.icon),
                  _react2['default'].createElement(_IconChevronNext2['default'], _extends({}, iconProps, { decorative: true }))
                )
              )
            )
          )
        );
      }

      return render;
    }()
  }]);

  return HorizontalScroll;
}(_react2['default'].Component);

HorizontalScroll.componentCategory = 'Private';
HorizontalScroll.displayName = 'HorizontalScroll';


HorizontalScroll.propTypes = propTypes;
HorizontalScroll.defaultProps = defaultProps;

var HorizontalScrollWithStyles = (0, _withStyles.withStyles)(function (_ref4) {
  var color = _ref4.color,
      unit = _ref4.unit;
  return {
    container: {
      position: 'relative'
    },

    button: Object.assign({
      background: color.clear,
      border: 0,
      cursor: 'pointer',
      height: '100%',
      margin: 0,
      padding: 0,
      position: 'absolute',
      top: 0

    }, (0, _removeFirefoxButtonPadding2['default'])()),

    button_transition: {
      // "transition" on z-index to avoid blocking clicks when hidden
      transitionProperty: 'opacity, z-index',
      transitionDuration: '300ms, 0ms',
      transitionTimingFunction: 'ease-out'
    },

    button_backwards: {
      left: 0
    },

    button_forwards: {
      right: 0
    },

    button_visible: {
      opacity: 1,
      zIndex: 0
    },

    button_visible_transition: {
      transitionDelay: '0ms, 0ms'
    },

    button_hidden: {
      opacity: 0,
      zIndex: -1
    },

    button_hidden_transition: {
      transitionDelay: '0ms, 300ms'
    },

    iconContainer: {
      backgroundColor: color.white,
      display: 'inline-block',
      height: '100%',
      position: 'relative',
      verticalAlign: 'top'
    },

    iconContainer_backwards: {
      paddingRight: 0.5 * unit
    },

    iconContainer_forwards: {
      paddingLeft: 0.5 * unit
    },

    icon: {
      color: color.core.hof,
      position: 'relative',
      top: '50%',
      transform: 'translateY(-50%)'
    },

    gradient: {
      display: 'inline-block',
      height: '100%',
      verticalAlign: 'top',
      width: 20
    },

    gradient_backwards: {
      background: 'linear-gradient(to left, ' + String(color.opacity(color.white, 0)) + ', ' + String(color.white) + ')'
    },

    gradient_forwards: {
      background: 'linear-gradient(to right, ' + String(color.opacity(color.white, 0)) + ', ' + String(color.white) + ')'
    }
  };
})(HorizontalScroll);

exports['default'] = (0, _reactWithDirection2['default'])(HorizontalScrollWithStyles);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/private/HorizontalScroll.js
// module id = 152
// module chunks = 923280921217 19843951674672